import { useMemo } from 'react';

import { Currency, TOKENS } from '@/constants';

const useDecomposeToken = (tokenDescriptor: Currency) => {
  const [token, tokenChain] = tokenDescriptor.split('_');

  const { fullName, type } = TOKENS.find((t) => t.name === tokenDescriptor) || {};

  return useMemo(
    () => ({
      token,
      chain: tokenChain,
      type,
      fullName,
      readableName: token.concat(tokenChain ? ` (${tokenChain})` : ''),
    }),
    [tokenDescriptor]
  );
};

export default useDecomposeToken;
